var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "handoff" },
    [
      _c("div", { staticClass: "handoff__container" }, [
        _c("div", { staticClass: "handoff__picture-container" }, [
          _c("img", {
            staticClass: "handoff__picture-container--img lazy",
            attrs: { src: "/static/images/grid.svg", alt: "grid" }
          }),
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "handoff__button-video",
              on: {
                mouseover: function($event) {
                  _vm.isHovered = true
                },
                mouseleave: function($event) {
                  _vm.isHovered = false
                },
                click: function($event) {
                  _vm.showVideoModal = !_vm.showVideoModal
                }
              }
            },
            [
              _c("button-view", { attrs: { variant: "rounded" } }, [
                _c(
                  "svg",
                  {
                    staticClass: "handoff__play-icon",
                    attrs: {
                      width: "60",
                      height: "69",
                      viewBox: "0 0 60 69",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d:
                          "M4.12521 64.4578L56.1002 34.4501L4.1252 4.44229L4.12521\n                  64.4578ZM57.9002 37.5678C60.3002 36.1821 60.3002 32.718 57.9002\n                  31.3324L5.9252 1.32459C3.52521 -0.0610511 0.525204 1.67101 0.525204\n                  4.44229L0.525201 64.4578C0.525201 67.2291 3.52521 68.9612 5.92521\n                  67.5755L57.9002 37.5678Z",
                        fill: "white"
                      }
                    })
                  ]
                )
              ]),
              _c("p", { staticClass: "handoff__button-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("handoff_teaser_button")) +
                    "\n        "
                )
              ])
            ],
            1
          )
        ]),
        _c("h2", { staticClass: "handoff__title" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("handoff_title")) + "\n    ")
        ]),
        _c("p", { staticClass: "handoff__subtitle" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("handoff_subtitle")) + "\n    ")
        ]),
        _c("p", { staticClass: "handoff__description" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("handoff_description")) + "\n    ")
        ]),
        _c(
          "a",
          {
            attrs: {
              href: "https://handoff.blissapplications.com/",
              target: "_blank"
            }
          },
          [
            _c(
              "button",
              { staticClass: "button button--primary handoff__button" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("handoff_link_button")) +
                    "\n      "
                )
              ]
            )
          ]
        )
      ]),
      _vm.showVideoModal === true
        ? _c("modal-view", {
            on: {
              closeModal: function($event) {
                _vm.showVideoModal = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "modal__video" }, [
                        _c("iframe", {
                          attrs: {
                            width: "560",
                            height: "315",
                            src: _vm.handoffUrl,
                            frameborder: "0",
                            allow: "autoplay;",
                            title: "Handoff – Mini Doc (Trailer)"
                          }
                        })
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2567930422
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", { staticClass: "handoff__preview" }, [
      _c("source", { attrs: { media: "", src: "/static/images/handoff.svg" } }),
      _c("img", {
        staticClass: "lazy",
        attrs: { "data-sizes": "auto", src: "/static/images/handoff.svg" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cacc051", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cacc051","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handoff/handoff-view.vue
// module id = 444
// module chunks = 54